import { render } from "./TextareaModal.vue?vue&type=template&id=3c378724&scoped=true"
import script from "./TextareaModal.vue?vue&type=script&lang=js"
export * from "./TextareaModal.vue?vue&type=script&lang=js"

import "../../../../reports/css/modal.css?vue&type=style&index=0&id=3c378724&scoped=true&lang=css"
import "./TextareaModal.vue?vue&type=style&index=1&id=3c378724&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c378724"]])

export default __exports__